/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1TutoraiDocumentsQueryResponse,
  GetApiV1TutoraiDocumentsQueryParams,
  GetApiV1TutoraiDocuments401,
  GetApiV1TutoraiDocuments500,
} from "../../types/tutorAIDocumentosController/GetApiV1TutoraiDocuments.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1TutoraiDocuments } from "../../clients/tutorAIDocumentosController/getApiV1TutoraiDocuments.ts";

export const getApiV1TutoraiDocumentsQueryKey = (
  params?: GetApiV1TutoraiDocumentsQueryParams,
) =>
  [{ url: "/api/v1/tutorai/documents" }, ...(params ? [params] : [])] as const;

export type GetApiV1TutoraiDocumentsQueryKey = ReturnType<
  typeof getApiV1TutoraiDocumentsQueryKey
>;

export function getApiV1TutoraiDocumentsQueryOptions(
  params?: GetApiV1TutoraiDocumentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1TutoraiDocumentsQueryKey(params);
  return queryOptions<
    GetApiV1TutoraiDocumentsQueryResponse,
    ResponseErrorConfig<
      GetApiV1TutoraiDocuments401 | GetApiV1TutoraiDocuments500
    >,
    GetApiV1TutoraiDocumentsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1TutoraiDocuments(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os documentos cadastrados para a turma. **(Requer Authorization para autenticação)**
 * @summary Listar documentos (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents}
 */
export function useGetApiV1TutoraiDocuments<
  TData = GetApiV1TutoraiDocumentsQueryResponse,
  TQueryData = GetApiV1TutoraiDocumentsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1TutoraiDocumentsQueryKey,
>(
  params?: GetApiV1TutoraiDocumentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1TutoraiDocumentsQueryResponse,
        ResponseErrorConfig<
          GetApiV1TutoraiDocuments401 | GetApiV1TutoraiDocuments500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1TutoraiDocumentsQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1TutoraiDocumentsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1TutoraiDocuments401 | GetApiV1TutoraiDocuments500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
